import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { DeviceService } from 'src/app/services/device.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'app-establecimientos',
  templateUrl: './establecimientos.component.html',
  styleUrls: ['./establecimientos.component.css']
})
export class EstablecimientosComponent{

  devicesAndEstablishmentInfo: any[] = []; //Información completa de los dispositivos y establecimientos
  datosRecibidos: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  errorMessage : string = ""; //Mensaje de error
  displayedColumns: string[] = ['external_id', 'est_name', 'razon_social', 'created_at', 'updated_at', 'status', 'nDevices', 'nTanks', 'operaciones'];
  dataSource :any;
  numeroEstablecimientos: number = 0;
  pageSizeOptions: number[] = [5, this.numeroEstablecimientos];
  userDataInfo: any = [];

  private establecimientoSubscription: Subscription | undefined;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @Input() userData: any;

  constructor(private deviceService: DeviceService, private error429: Error429Service, private userDataService: UserDataService){
    this.userDataInfo = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    if(this.userDataInfo.pro_id != "4"){
      this.displayedColumns = ['external_id', 'est_name', 'created_at', 'updated_at', 'status', 'nDevices','nTanks', 'operaciones'];
    }
    this.establecimientoSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          let status;
          if(resp[i].status == 1){
            status = "Activado";
          } else {
            status = "Desactivado";
          }
          let nTanks = 0;
          if(resp[i].devices.length !==0){
            for(let j = 0; j < resp[i].devices.length; j++){
              nTanks += resp[i].devices[j].tanks.length;
            }
          }
          const establishmentInfo : any = {
            id: resp[i].id,
            external_id: resp[i]?.external_id,
            est_name: resp[i].est_name,
            razon_social: resp[i].cliente.razon_social,
            created_at: this.formatDateTime(resp[i].created_at),
            updated_at: this.formatDateTime(resp[i].updated_at),
            status: status,
            nDevices: resp[i].devices.length,
            nTanks: nTanks,
          };
          this.devicesAndEstablishmentInfo.push(establishmentInfo);
        }
        this.dataSource = new MatTableDataSource(this.devicesAndEstablishmentInfo);
        this.dataSource.filterPredicate = (data: any, filter: string) => {
          const dataStr = this.displayedColumns
            .filter(key => key !== 'id')
            .map(key => data[key])
            .join('')
            .toLowerCase();
      
          return dataStr.includes(filter);
        };
        setTimeout(() => {
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }, 0);
        // Función de comparación personalizada al MatSort para la propiedad cliente.razon_social
        /*this.dataSource.sortingDataAccessor = (item: any, property: any) => {
          if (property === 'cliente.razon_social') {
            return item.cliente.razon_social.toLowerCase(); // O cualquier propiedad que uses para ordenar
          }
          return item[property];
        };*/
        //Filtrado personalizado para que no tenga en cuenta el id del tanque.
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.datosRecibidos = true;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.establecimientoSubscription) {
      this.establecimientoSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para convertir la fecha
  formatDateTime(dateTimeString: string | null): string {
    if (dateTimeString !== null) {
      const inputDate = new Date(dateTimeString);
      const year = inputDate.getFullYear();
      const month = ('0' + (inputDate.getMonth() + 1)).slice(-2);
      const day = ('0' + inputDate.getDate()).slice(-2);
      const hours = ('0' + inputDate.getHours()).slice(-2);
      const minutes = ('0' + inputDate.getMinutes()).slice(-2);
      const seconds = ('0' + inputDate.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    return '';
  }

  customFilterPredicate(data: any, filter: string): boolean {
    const dataStr = JSON.stringify(data).toLowerCase();
    const searchStr = filter.toLowerCase();
    return dataStr.indexOf(searchStr) !== -1;
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  descargarExcel(){
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'External ID', key: 'id', width: 20 },
      { header: 'Nombre', key: 'est_name', width: 30 },
      { header: 'Cliente', key: 'razon_social', width: 30 },
      { header: 'Fecha de alta', key: 'created_at', width: 20 },
      { header: 'Modificado', key: 'updated_at', width: 20 },
      { header: 'Status', key: 'status', width: 20 },
      { header: 'Nº de dispositivos', key: 'nDevices', width: 20 },
      { header: 'Nº de tanques', key: 'nTanks', width: 20 },
    ];
    /*this.devicesAndEstablishmentInfo.forEach(establecimiento => {
      worksheet.addRow(establecimiento);
    });*/
    this.devicesAndEstablishmentInfo.forEach(establecimiento => {
      const formattedEstablecimiento = {
        id: establecimiento.external_id,
        est_name: establecimiento.est_name,
        razon_social: establecimiento.razon_social,
        created_at: this.formatDateTime(establecimiento.created_at), // Aplica la función formatDateTime a la fecha
        updated_at: this.formatDateTime(establecimiento.updated_at), // Aplica la función formatDateTime a la fecha
        status: establecimiento.status,
        nDevices: establecimiento.nDevices,
        nTanks: establecimiento.nTanks,
      };
      const row = worksheet.addRow(formattedEstablecimiento);
      //Ajustar tamaño de las celdas
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        // Ajustar el ancho de la columna basado en el tamaño del contenido
        const columnWidth = cell.text.length + 4;
    
        // Obtener la referencia a la columna actual
        const currentColumn = worksheet.getColumn(colNumber);
    
        // Asegurarse de que la columna exista antes de intentar ajustar su ancho
        if (currentColumn) {
          // Comparar y actualizar el ancho máximo
          currentColumn.width = Math.max(currentColumn.width || 0, columnWidth);
        }
      });
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Listado establecimientos DataBeer.xlsx');
    });
  }

}
